import { useContent } from "../hooks/useContent";
import * as Icons from "lucide-react";
import React from "react";
const CoursesSection = () => {
	const { data: content, isLoading } = useContent();
	const hero = content?.hero;
	const courses = content?.courses;
	const whyChooseUs = content?.whyChooseUs;
	const contact = content?.contact;
	console.log("Courses content:", courses);
	return (
		<section id="courses" className="py-24 px-4 bg-background">
			<div className="max-w-6xl mx-auto">
				<div className="text-center mb-16">
					<p className="text-accent font-heading text-lg tracking-widest uppercase mb-2">What We Teach</p>
					<h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
						Our Courses
					</h2>
					<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
				{courses && courses.length > 0 && courses.map((course, index) => (
					<div
						key={course.name}
						className="group bg-card border-2 border-gold/30 rounded-lg p-8 text-center hover:shadow-gold-lg hover:-translate-y-2 transition-all duration-300 cursor-pointer"
						style={{ animationDelay: `${index * 0.1}s` }}
					>
						<div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-300">
							{Icons[course.icon] && React.createElement(Icons[course.icon], { className: "w-8 h-8 text-primary group-hover:text-accent transition-colors duration-300" })}
						</div>
						<h3 className="text-xl font-display font-semibold text-foreground mb-3">
							{course.name}
						</h3>
						<p className="text-muted-foreground font-body text-sm leading-relaxed">
							{course.description}
						</p>
					</div>
				))}
				</div>
			</div>
		</section>
	);
};

export default CoursesSection;
